import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchUtmMapSettings,
  type UtmMapSettings,
  updateUtmMapSettings,
} from '@/services/utm/utm-api';

const UTM_MAP_SETTINGS_QUERY_KEY = ['utm-map-settings'] as const;

export const useUtmMapSettings = () => {
  return useQuery<UtmMapSettings>({
    queryKey: UTM_MAP_SETTINGS_QUERY_KEY,
    queryFn: fetchUtmMapSettings,
    staleTime: 5 * 60 * 1000,
  });
};

export const useUpdateUtmMapSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateUtmMapSettings,
    onSuccess: (data) => {
      queryClient.setQueryData(UTM_MAP_SETTINGS_QUERY_KEY, data);
    },
  });
};
